import { white } from '@kmns-internal/furikake'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import {
  type GridVariable,
  type PlaceNode,
  PlaceNodeTypeEnum,
  type Template,
} from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { Link } from 'react-router-dom'
import date from 'src/exShared/util/date'
import { useGridVariableTemplates } from './Templates.hooks'

const GridVariablesList = () => {
  const {
    data: { templates },
  } = useGridVariableTemplates()

  return (
    <Table sx={{ bgcolor: white }} stickyHeader>
      <TableHead>
        <TableRow sx={{ backgroundColor: '#fff' }}>
          <TableCell size="small" sx={{ fontWeight: 'bold' }}>
            ひな形名
          </TableCell>
          <TableCell size="small" sx={{ fontWeight: 'bold' }}>
            現場名
          </TableCell>
          <TableCell size="small" sx={{ fontWeight: 'bold' }}>
            更新日時
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {templates.map((template: Template) => (
          <Row key={template.id} template={template} />
        ))}
      </TableBody>
    </Table>
  )
}

/**
 * 各行の表示に必要なひな形情報
 */
interface TemplateRowData {
  id?: number
  name: string
  placeNodes?: Array<PlaceNode>
  gridVariable?: GridVariable
}

const Row: FC<{
  template: TemplateRowData
}> = ({ template }) => {
  const getPlaceNames = (placeNodes: PlaceNode[]) =>
    placeNodes
      .map(({ type, place, placeGroup }) =>
        type === PlaceNodeTypeEnum.PlaceGroup ? placeGroup?.name : place?.name,
      )
      .filter(name => name)
      .join(' ')

  return (
    <TableRow
      hover
      component={Link}
      to={`/gridVariables/${template.id}/edit`}
      key={template.id}
      sx={{
        textDecoration: 'none',
      }}
    >
      <TableCell>{template.name}</TableCell>
      <TableCell>{getPlaceNames(template.placeNodes ?? [])}</TableCell>
      <TableCell>
        {!template.gridVariable?.updatedAt
          ? ''
          : date.formatYYYYMMDDHHMM(template.gridVariable.updatedAt)}
      </TableCell>
    </TableRow>
  )
}

export default GridVariablesList
